import { NodeType } from "../app.types";

// List of node types which don't have detail page and ref view
export const NON_ASSET_ITEMS: NodeType[] = ["DMN", "CAT"];
